export default __webpack_public_path__ + "static/Hepatofelin-home-@3x-837648c5db07248023ca398616f2dae4.jpg";